import { useEffect, useState } from "react";

function scoreColor(score) {
  if (score <= 30) return "#DC2626";
  if (score <= 60) return "#EA580C";
  if (score <= 85) return "#EAB308";
  return "#16A34A";
}

function scoreLabel(score) {
  if (score <= 30) return "Alta exposición";
  if (score <= 60) return "Exposición moderada";
  if (score <= 85) return "Casi protegido";
  return "Bien protegido";
}

export default function PrivacyScoreDial({ score = 0, size = 220 }) {
  const [animated, setAnimated] = useState(0);
  useEffect(() => {
    const start = performance.now();
    const dur = 1200;
    let raf;
    const tick = (now) => {
      const t = Math.min(1, (now - start) / dur);
      setAnimated(Math.round(score * (1 - Math.pow(1 - t, 3))));
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [score]);

  const r = (size - 24) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (animated / 100) * c;
  const color = scoreColor(animated);

  return (
    <div className="inline-flex flex-col items-center" data-testid="privacy-score-dial">
      <svg width={size} height={size} className="block">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="#E5E7EB" strokeWidth="10" fill="none" />
        <circle
          cx={size / 2} cy={size / 2} r={r}
          stroke={color} strokeWidth="10" fill="none" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={offset}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: "stroke 0.4s ease" }}
        />
        <text x="50%" y="48%" textAnchor="middle" dominantBaseline="middle"
              className="font-display" fontSize={size * 0.32} fontWeight="800" fill="#111">
          {animated}
        </text>
        <text x="50%" y="68%" textAnchor="middle" fontSize="11" fontWeight="700" fill="#6B7280" style={{ letterSpacing: "0.2em" }}>
          /100
        </text>
      </svg>
      <div className="mt-3 px-3 py-1 text-xs uppercase tracking-[0.18em] font-bold border border-gray-200 rounded-full"
           style={{ color }}>
        {scoreLabel(animated)}
      </div>
    </div>
  );
}
